import { render, staticRenderFns } from "./StudentAdvisorView.vue?vue&type=template&id=2d7ef3a0&"
import script from "./StudentAdvisorView.vue?vue&type=script&lang=js&"
export * from "./StudentAdvisorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports